import axios from "./http.js"; // 导入http中创建的axios实例
const Api = {
  userInfo(data) {
    // 用户信息
    return axios.post("/cas/info", data);
  },
  chatList(data) {
    // 会话历史
    return axios.post("/chat-list", data);
  },
  //会话新增
  chatAdd(data) {
    return axios.post("/chat-add", data);
  },
  //会话编辑
  chatUpdate(data) {
    return axios.post("/chat-update", {
      token: window.localStorage.getItem("token"),
      ...data,
    });
  },
  //会话删除
  chatDel(id) {
    return axios.post("/chat-del", {
      token: window.localStorage.getItem("token"),
      chat_id: id,
    });
  },
  //会话清空
  chatClear(data) {
    return axios.post("/chat-clear", {
      token: window.localStorage.getItem("token"),
      ...data,
    });
  },
  getdepart(data) {
    // 科室列表
    return axios.post("/qa/department", data);
  },
  getdepartquestion(data) {
    // 问题
    return axios.post("/qa/departmentQa", data);
  },
  todayNum(data) {
    // 今日剩余问答次数
    return axios.post("/qa/todayNum", data);
  },
  vipEquity(data) {
    // VIP权益
    return axios.post("/vip-equity", data);
  },
  buyVipPlace(data) {
    //会员购买
    return axios.post("/vip-place-order", data);
  },
  vipOrderList(data) {
    //订单列表
    return axios.post("/vip-order-list", data);
  },
  vipOrderDel(data) {
    //订单删除
    return axios.post("/vip-order-del", data);
  },
  qaCheck(data) {
    //提问前校验
    return axios.post("/qa-check", data);
  },
  //推荐词列表
  putforwardList(data) {
    return axios.post("/putforward-list", data);
  },
  //用户登录
  appLogin(data) {
    return axios.get("/cas/auth", { params: data });
  },
  // AI场景面板
  getAIMapList(data) {
    return axios.get("/tool-list", { params: data });
  },
  // 我的工具列表
  getMyTool(data) {
    return axios.get("/my-tool", { params: data });
  },
  // 添加工具
  addTool(data) {
    return axios.post("/add-tool", data);
  },
  // 删除工具
  delTool(data) {
    return axios.post("/del-tool", data);
  },
  //上传文件转译PDF
  uploadFile(data) {
    return axios.post("/upload-file", data, { 
      timeout: 0,
      headers:{
        "Content-Type": "multipart/form-data",}
     });
  },
  //PDF阅读助手
  getPDFRead(data) {
    return axios.post("/pdf-read", data, { 
      timeout: 0,
      headers:{
        "Content-Type": "multipart/form-data",}
     });
  },
  getPDFQuestions(data){
    return axios.get("/related-issues", {
      timeout: 0,
      params: data
    });
  }
};

export default Api;
